import {useIntl} from 'react-intl'
import {CreateFields, StoreFinderSearchBarFormFields} from '../../types/forms'

export const useStoreFinderSearchBarFields: CreateFields<StoreFinderSearchBarFormFields> = ({
  form: {
    control,
    formState: {errors},
  },
}) => {
  const {formatMessage} = useIntl()

  const fields = {
    storeFinder: {
      name: `storeFinder`,
      label: 'Town, City or Postcode',
      defaultValue: '',
      type: 'text' as const,
      error: errors[`storeFinder`],
      rules: {
        required: formatMessage({defaultMessage: 'This field is required.'}),
      },
      inputProps: {
        id: 'store-finder-address-input',
        // See: https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
        autoComplete: 'new-password',
      },
      control,
    },
  }

  return fields
}
